import React from "react";
import Storage from "../../services/storage.service";
import Translations from "../../services/translation.service";
import FirebaseAnalytics from "../../services/analytics.service";
import StorefrontTitle from "../shared/storefront-title.component";
import SuccessImg from "../../assets/img/correct.svg";

const EligibilitySuccess = props => {
  let prefix = "3.3.2.A";
  const eligibilityDone = () => {
    let flags = Storage.get("flags");
    flags.IsEligible = true;
    Storage.set("flags", flags);
  };
  return (
    <div className="stf-eligibility-cntnr stf-eligibility-cntnr-margin">
      <img src={SuccessImg} alt="" />
      <StorefrontTitle
        title={Translations.keys[prefix + "_congratulations"]}
        desc={Translations.keys[prefix + "_you_are_eligible"]}
      />
      <button
        className={"common-button"}
        onClick={() => {
          FirebaseAnalytics.button_clicked(
            prefix + "_btn_label"
          );
          eligibilityDone();
        }}
      >
        {Translations.keys[prefix + "_btn_label"]}
      </button>
    </div>
  );
};
export default EligibilitySuccess;
